import React from "react";
import { DroppedFile as BaseDroppedFile } from "@/components/DroppedFile";
import { Input } from "@/components/Input";
import { IconMessage } from "@/components/IconMessage";
import { Button } from "@/components/Button";
import useTranslation from "next-translate/useTranslation";
import { useTheme } from "@/hooks/useTheme";

interface IProps {
  file: File;
  onFileSubmit: () => void;
  onFileReset: () => void;
}

export const DroppedFile: React.FC<IProps> = props => {
  const { file, onFileReset, onFileSubmit } = props;

  const [email, setEmail] = React.useState("");
  const [isError, setIsError] = React.useState(false);

  const { t } = useTranslation("converter");
  const { bp } = useTheme();

  const handleInputChange: React.ChangeEventHandler<HTMLInputElement> = event => {
    setEmail(event.target.value);
    setIsError(false);
  };

  return (
    <BaseDroppedFile
      file={file}
      onFileSubmit={onFileSubmit}
      onFileReset={onFileReset}
    >
      <Input
        required
        type="email"
        value={email}
        onChange={handleInputChange}
        placeholder={t("selectingFile.enterYourEmail")}
        customStyle={{ marginTop: 28 }}
      />

      {isError && <IconMessage message={t("selectingFile.enterValidEmail")} />}

      <Button
        type="submit"
        customStyle={{
          marginTop: 24,
          maxWidth: 185,
          alignSelf: "center",

          [bp.FROM_TABLET]: {
            marginTop: 24,
          },
        }}
        title={t("selectingFile.uploadNow")}
      >
        {t("selectingFile.uploadNow")}
      </Button>
    </BaseDroppedFile>
  );
};
